export enum ETipoFrete {
  CIFRemetente = 0,
  FOBDestinatario = 1,
  Terceiros = 2,
  TransporteProprioRemetente = 3,
  TransporteProprioDestinatario = 4,
  SemOcorrenciaTransporte = 9,
}
